/*
 * @Desc: 项目核心文件
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: 赵佳明
 * @LastEditTime: 2023-02-03 10:01:15
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved.
 */
import Vue from 'vue';
import router from './router/index';
// import VueAxios from 'vue-axios'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 悬浮样式配置
import './styles/hover.css';

// 打印机配置
import Typed from 'typed.js';

// 渐入渐出配置
import ScrollReveal from 'scrollreveal';

// 注册全局组件 渐出渐入
import SRF from './components/SRF';

// 首页模板
import App from './App.vue';
// 状态管理
import Vuex from 'vuex';
import route from './store/modules/route';

import axios from 'axios';
Vue.use(ElementUI);
Vue.prototype.Typed = Typed;
Vue.prototype.sr = ScrollReveal;
Vue.prototype.toICP = () => window.open('https://beian.miit.gov.cn/', '_blank');
Vue.component('SRF', SRF);
Vue.prototype.ICPtext = () =>
  location.origin.includes('shanmuzhi')
    ? '冀ICP备18022578号-5'
    : '冀ICP备18022578号-4';
function mobileskip() {
  var mobileAgent = new Array(
    'iphone',
    'ipod',
    'ipad',
    'android',
    'mobile',
    'blackberry',
    'webos',
    'incognito',
    'webmate',
    'bada',
    'nokia',
    'lg',
    'ucweb',
    'skyfire'
  );
  var browser = navigator.userAgent.toLowerCase();
  var isMobile = false; // 记录是否移动端
  for (var i = 0; i < mobileAgent.length; i++) {
    if (browser.indexOf(mobileAgent[i]) != -1) {
      isMobile = true;
      break;
    }
  }
  return isMobile;
}

// 全局参数
const publicData = {};

Vue.prototype.$ismobile = mobileskip(); // 是否为移动端
Vue.prototype.publicData = publicData;
Vue.prototype.$axios = axios;
Vue.prototype.getImgUrl = (url) => 'http://admin.shanmuzhi.com' + url;
// : 'http://smzgwadmin.shanmuzhi.com' + url;

Vue.prototype.cleanHtmlText = (htmlText) => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = htmlText;
  let text = textarea.value;
  text = text.replace(/<p[^>]*>/g, '');
  text = text.replace(/<\/p>/g, '');
  text = text.replace(/\s+/g, ' ').trim();
  return text;
};

Vue.config.productionTip = false;

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    route,
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
